const MODULE_NAME = 'PATIENT_MEASUREMENTS_ECGS_';
const FETCH_STARTED = MODULE_NAME + 'FETCH_STARTED';
const FETCH_COMPLETED = MODULE_NAME + 'FETCH_COMPLETED';
const FETCH_DETAIL_STARTED = MODULE_NAME + 'FETCH_DETAIL_STARTED';
const FETCH_DETAIL_COMPLETED = MODULE_NAME + 'FETCH_DETAIL_COMPLETED';
const MARK_SEEN_STARTED = MODULE_NAME + 'MARK_SEEN_STARTED';
const MARK_SEEN_COMPLETED = MODULE_NAME + 'MARK_SEEN_COMPLETED';

export {
  FETCH_STARTED,
  FETCH_COMPLETED,
  FETCH_DETAIL_STARTED,
  FETCH_DETAIL_COMPLETED,
  MARK_SEEN_STARTED,
  MARK_SEEN_COMPLETED
};
